/**
 * Stable CSS class names for E2E — TaskAnalyzer page.
 * Layout/visual blocks under `.task-analyzer` remain in `TaskAnalyzer.scss`.
 */
export const TA = {
    page: 'task-analyzer-page',
    root: 'task-analyzer',

    inputSection: 'task-analyzer__input-section',
    inputSectionHeader: 'task-analyzer__input-section-header',
    inputSectionIcon: 'task-analyzer__input-section-icon',
    inputSectionTitle: 'task-analyzer__input-section-title',
    inputDescription: 'task-analyzer__input-description',
    taskDescriptionInput: 'task-analyzer-input--task-description',
    inputActions: 'task-analyzer__input-actions',
    btnClear: 'task-analyzer-input--button-clear',
    btnAnalyze: 'task-analyzer-input--button-analyze',

    progressSection: 'task-analyzer__progress-section',
    linearProgress: 'task-analyzer__linear-progress',
    progressMessage: 'task-analyzer__progress-message',

    errorAlert: 'task-analyzer__error-alert',

    results: 'task-analyzer__results',
    scoreSection: 'task-analyzer__score-section',
    scoreSectionHeader: 'task-analyzer__score-section-header',
    resultTitleBlock: 'task-analyzer__result-title-block',
    resultTitle: 'task-analyzer__result-title',
    resultSummary: 'task-analyzer__result-summary',
    scoreValueBlock: 'task-analyzer__score-value-block',
    scoreValue: 'task-analyzer__score-value',
    scoreMax: 'task-analyzer__score-max',
    scoreDivider: 'task-analyzer__score-divider',
    chipsRow: 'task-analyzer__chips-row',
    chipsGroup: 'task-analyzer__chips-group',
    chipCritical: 'task-analyzer__chip-critical',
    chipWarning: 'task-analyzer__chip-warning',
    chipOk: 'task-analyzer__chip-ok',
    btnExportMd: 'task-analyzer-input--button-export-md',

    criticalInfoAlert: 'task-analyzer__critical-info-alert',

    categories: 'task-analyzer__categories',
    /** Base card; append `--${status}` for modifier (styled in SCSS). */
    categoryCard: 'task-analyzer__category-card',
    categoryCardContent: 'task-analyzer__category-card-content',
    categoryHeader: 'task-analyzer__category-header',
    categoryTitleGroup: 'task-analyzer__category-title-group',
    categoryStatusIcon: 'task-analyzer__category-status-icon',
    categoryTitle: 'task-analyzer__category-title',
    categoryStatusChip: 'task-analyzer__category-status-chip',
    categoryQuestionCount: 'task-analyzer__category-question-count',
    categoryExpandIcon: 'task-analyzer__category-expand-icon',
    categoryCollapseBody: 'task-analyzer__category-collapse-body',
    categoryFeedback: 'task-analyzer__category-feedback',

    questions: 'task-analyzer__questions',
    questionItem: 'task-analyzer__question-item',
    questionRow: 'task-analyzer__question-row',
    questionHelpIcon: 'task-analyzer__question-help-icon',
    questionText: 'task-analyzer__question-text',
    questionAnswerInput: 'task-analyzer-input--question-answer',

    updateSection: 'task-analyzer__update-section',
    /** Kept for existing SCSS (`.task-analyzer__update-btn`). */
    updateTaskButton: 'task-analyzer__update-btn',
} as const;

export const taCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
